"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaginationControls = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _PTTLayout = require("../PTTLayout");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var MAX_PAGES_SHOWN = 5;

/**
 * Pagination controls: previous, next, first, last, jump to.
 *  - If totalPages is null, we don't know the total number of pages, so we don't show the first/last buttons
 *  - If totalPages is undefined, we know the total number of pages, but it's incorrect (e.g. the dataset changed). The last known value (or null) is used.
 *  - If totalPages is a number, that number is used.
 *
*/
var PaginationControls = function PaginationControls(_ref) {
  var currentPage = _ref.currentPage,
      totalPages = _ref.totalPages,
      onPageChange = _ref.onPageChange;
  // Current page, try to convert it to int (floor). If fails, fallback to 1
  var currentPageInt = isNaN(Math.floor(currentPage)) ? 1 : Math.floor(currentPage); // For totalPages:
  // - null === unknown (for large dataset we sometimes don't have access to the total), 
  // - undefined === incorrect value
  // Remember the last correct value, or 1

  var totalRef = _react["default"].useRef(null);

  _react["default"].useEffect(function () {
    if (totalPages !== undefined) {
      totalRef.current = totalPages;
    }
  }, [totalPages]); // If converted value is invalid, use the last remembered value


  var totalPagesFinal = totalPages === undefined ? totalRef.current : totalPages;
  var pageStart = totalPagesFinal !== null ? Math.min(totalPagesFinal, Math.max(currentPageInt - Math.floor(MAX_PAGES_SHOWN / 2), 1)) : currentPageInt;
  var pageEnd = totalPagesFinal !== null ? Math.min(pageStart + MAX_PAGES_SHOWN - 1, totalPagesFinal) : currentPageInt;
  var arePagesBefore = currentPageInt > 1;
  var arePagesAfter = totalPagesFinal !== null ? currentPageInt < totalPagesFinal : true;
  return /*#__PURE__*/_react["default"].createElement(Container, null, totalPagesFinal !== null && /*#__PURE__*/_react["default"].createElement(PaginationButton, {
    onClick: function onClick() {
      return onPageChange(1);
    },
    disabled: !arePagesBefore,
    "aria-label": "Go to first page"
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "fas fa-chevron-double-left"
  })), /*#__PURE__*/_react["default"].createElement(PaginationButton, {
    onClick: function onClick() {
      return onPageChange(currentPageInt - 1);
    },
    disabled: !arePagesBefore,
    "aria-label": "Go to previous page"
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "fas fa-chevron-left"
  })), /*#__PURE__*/_react["default"].createElement(_PTTLayout.Flex, null, _toConsumableArray(Array(pageEnd - pageStart + 1)).map(function (_, i) {
    var page = pageStart + i;
    return /*#__PURE__*/_react["default"].createElement(PaginationNumberButton, {
      key: page,
      onClick: function onClick() {
        return onPageChange(page);
      },
      $active: page === currentPageInt,
      "aria-label": "Go to page ".concat(page)
    }, page);
  })), /*#__PURE__*/_react["default"].createElement(PaginationButton, {
    onClick: function onClick() {
      return onPageChange(currentPageInt + 1);
    },
    disabled: !arePagesAfter,
    "aria-label": "Go to next page"
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "fas fa-chevron-right"
  })), totalPagesFinal !== null && /*#__PURE__*/_react["default"].createElement(PaginationButton, {
    onClick: function onClick() {
      return onPageChange(totalPagesFinal);
    },
    disabled: !arePagesAfter,
    "aria-label": "Go to last page"
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "fas fa-chevron-double-right"
  })), /*#__PURE__*/_react["default"].createElement(JumpTo, {
    totalPages: totalPagesFinal,
    onChange: onPageChange
  }));
};

exports.PaginationControls = PaginationControls;

var JumpTo = function JumpTo(_ref2) {
  var totalPages = _ref2.totalPages,
      onChange = _ref2.onChange;
  var inputIdSuffix = Math.random().toString(36).substring(7);
  var inputId = "jump-to-".concat(inputIdSuffix);

  var _React$useState = _react["default"].useState(),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      value = _React$useState2[0],
      setValue = _React$useState2[1];

  var handleSubmit = function handleSubmit(e) {
    e.preventDefault(); // Avoid refreshing the page on form submit

    var newPage = Math.max(0, value !== null && value !== void 0 ? value : 0);
    onChange(totalPages !== null ? Math.min(totalPages, newPage) : newPage);
    e.target.reset();
  };

  return /*#__PURE__*/_react["default"].createElement(JumpToHolder, {
    onSubmit: handleSubmit
  }, /*#__PURE__*/_react["default"].createElement(JumpToLabel, {
    htmlFor: inputId
  }, "Go to page:"), /*#__PURE__*/_react["default"].createElement(JumpToInput, {
    id: inputId,
    required: true,
    type: "number",
    min: 1,
    max: totalPages !== null && totalPages !== void 0 ? totalPages : undefined,
    onChange: function onChange(e) {
      return setValue(parseInt(e.target.value));
    }
  }), /*#__PURE__*/_react["default"].createElement(JumpToSubmit, {
    type: "submit",
    "aria-label": "Submit page change"
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "fas fa-chevron-right"
  })));
};

var Container = _styledComponents["default"].div.withConfig({
  displayName: "PaginationControls__Container",
  componentId: "sc-13asc20-0"
})(["display:flex;align-items:center;gap:20px;font-family:var(--blox-font-family);"]);

var PaginationButton = _styledComponents["default"].button.attrs({
  className: 'blox text grey'
}).withConfig({
  displayName: "PaginationControls__PaginationButton",
  componentId: "sc-13asc20-1"
})(["&&&{i{font-size:15px;}}"]);

var PaginationNumberButton = (0, _styledComponents["default"])(PaginationButton).withConfig({
  displayName: "PaginationControls__PaginationNumberButton",
  componentId: "sc-13asc20-2"
})(["&&&{width:35px;height:35px;display:flex;align-items:center;line-height:37px;font-weight:400;border-radius:50%;", ";}"], function (_ref3) {
  var $active = _ref3.$active;
  return $active && "\n            background: var(--blox-blue) !important;\n            color: white !important;\n            font-weight: 700 !important;\n        ";
});

var JumpToHolder = _styledComponents["default"].form.withConfig({
  displayName: "PaginationControls__JumpToHolder",
  componentId: "sc-13asc20-3"
})(["position:relative;display:inline-block;"]);

var JumpToLabel = _styledComponents["default"].label.withConfig({
  displayName: "PaginationControls__JumpToLabel",
  componentId: "sc-13asc20-4"
})(["background-color:white;font-size:11px;left:9px;padding:0 4px;position:absolute;top:-50%;transform:translateY(70%);color:var(--blox-slate3);"]);

var JumpToInput = _styledComponents["default"].input.withConfig({
  displayName: "PaginationControls__JumpToInput",
  componentId: "sc-13asc20-5"
})(["background-color:white;border:2px solid var(--blox-slate2);border-radius:5px;box-sizing:border-box;color:var(--blox-slate3);font-size:15px;margin:0;padding:10px 24px 6px 8px;width:100px;box-shadow:inset 0 0 0 1px #eaedf2;display:inline-block;letter-spacing:1px;-moz-appearance:textfield;&::-webkit-outer-spin-button,&::-webkit-inner-spin-button{-webkit-appearance:none;}"]);

var JumpToSubmit = _styledComponents["default"].button.withConfig({
  displayName: "PaginationControls__JumpToSubmit",
  componentId: "sc-13asc20-6"
})(["background-color:initial;box-shadow:none;font-size:15px;margin:0;padding:0;position:absolute;right:0;top:50%;transform:translate(-100%,-50%);border:none;border-radius:3px;color:var(--slate3);cursor:pointer;display:inline-block;transition:all .25s ease;width:auto;height:auto;&:hover{color:var(--blox-blue);}"]);